import { render, staticRenderFns } from "./PopupAdd.vue?vue&type=template&id=809a8668&scoped=true&"
import script from "./PopupAdd.vue?vue&type=script&lang=js&"
export * from "./PopupAdd.vue?vue&type=script&lang=js&"
import style0 from "./PopupAdd.vue?vue&type=style&index=0&id=809a8668&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "809a8668",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VForm,VListItem,VListItemContent,VSpacer})
